import { type FC, lazy, Suspense } from "react";
import StorSpinner from "~/shared/components/stor-spinner";
import mbc from "~/shared/functions/mbc";
import { getMobilBankState } from "~/shared/hooks/use-navigate/useNavigateMBC";
import { SoftReRenderProvider } from "~/shared/hooks/use-soft-re-render";
import { deleteLocalStorageExpired } from "~/utils/local-storage";

const App = lazy(() => import("./App"));

function deleteLocalStorageStateOnFirstPage() {
	if (mbc.isNative() && !getMobilBankState().ikkeForsteSide) {
		Object.keys(localStorage)
			.filter((x) => x.startsWith("ppm-state-"))
			.forEach((x) => {
				localStorage.removeItem(x);
			});
		localStorage.removeItem("ppm-react-query");
	}
}

const Root: FC = () => {
	deleteLocalStorageStateOnFirstPage();
	deleteLocalStorageExpired();

	return (
		<Suspense fallback={<StorSpinner />}>
			<SoftReRenderProvider>
				<App />
			</SoftReRenderProvider>
		</Suspense>
	);
};
export default Root;
